import { motion } from "framer-motion";
import { PRODUCT_FAMILY } from "@/data/content";

export const ProductFamily = () => (
  <section data-testid="product-family-section" className="bg-baseLight px-6 pt-[20px] pb-[30px] sm:py-[40px] lg:px-12 lg:py-[70px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl lg:mx-auto lg:text-center"
      >
        <h2
          data-testid="product-family-headline"
          className="font-heading text-[30px] font-semibold leading-tight text-ink sm:text-[35px] lg:text-[41px]"
        >
          Choose the power class.
          <br className="hidden lg:block" />
          Configure the energy system
        </h2>
        <p data-testid="product-family-text" className="mt-[32px] lg:mt-5 text-[15px] leading-relaxed text-inkSoft">
          The H-series offers four power classes for agricultural and rural operations, with
          final configurations tailored to site-specific energy and backup requirements.
        </p>
      </motion.div>

      <div className="mt-[41px] grid grid-cols-1 divide-y divide-borderLight border-t border-borderLight sm:grid-cols-2 sm:divide-x sm:divide-y-0 lg:mt-16 lg:grid-cols-4">
        {PRODUCT_FAMILY.map((item, i) => (
          <motion.div
            key={item.model}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            data-testid={`product-family-item-${item.model}`}
            className="py-8 sm:px-7 sm:py-10 lg:px-9"
          >
            <span
              data-testid={`product-family-model-${item.model}`}
              className="block font-heading text-[57px] font-bold leading-none text-ink lg:text-[69px]"
            >
              {item.model}
            </span>
            <span className="mt-4 block text-sm font-medium text-teal">{item.power}</span>
            <span className="mt-3 block text-xs text-inkMuted">{item.storage}</span>
            <span className="mt-6 block text-xs font-medium uppercase tracking-[0.1em] text-inkMuted">
              Application
            </span>
            <span className="mt-1.5 block text-sm leading-relaxed text-inkSoft">{item.application}</span>
          </motion.div>
        ))}
      </div>

      <p data-testid="product-family-disclaimer" className="mt-[15px] max-w-2xl text-xs italic leading-relaxed text-inkMuted lg:mx-auto lg:mt-12 lg:text-center">
        Indicative product classes. Final system sizing and storage duration depend on site
        load, renewable-resource assessment, operating requirements and supplier-certified
        equipment ratings.
      </p>
    </div>
  </section>
);
